module.exports = __webpack_public_path__ + "img/41.dc329aa0.jpg";